// Active IFS account selection — persisted in localStorage, shared between
// the dashboard UI and the ifsService API client.
const STORAGE_KEY = 'ifs.activeAccountId';
let listeners = [];
export function getActiveIFSAccountId() {
    try {
        return localStorage.getItem(STORAGE_KEY);
    }
    catch {
        return null;
    }
}
export function setActiveIFSAccountId(id) {
    try {
        if (id)
            localStorage.setItem(STORAGE_KEY, id);
        else
            localStorage.removeItem(STORAGE_KEY);
    }
    catch {
        // ignore quota / SSR
    }
    listeners.forEach(fn => fn(id));
}
export function subscribeIFSAccount(fn) {
    listeners.push(fn);
    return () => { listeners = listeners.filter(l => l !== fn); };
}
